<template>
  <v-container class="login-container">

   <div class="screen index_screen">
        <div class="wrapper">
            <img class="logo" src="@/staff/img/logo.png">

            <section class="main_inner">
                <a class="btn color-white" href="/#/staffJoin">시작하기</a>
                <a href="/#/signin" class="index_login">이미 계정이 있나요? 로그인</a>
            </section>
        </div>         
    </div>  

  </v-container>
</template>

<script>
  
import '@/staff/css/style.css'
import '@/staff/css/0908_style.css'

import { required, email } from 'vee-validate/dist/rules'
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from 'vee-validate'
import { loginSuccess } from '@/api/native/native'

setInteractionMode('eager')

export default {
  data: () => ({
    phone: '',
    token: '',
    errors: '',
    autoLogin: false,
    alert: false,
    showPassword: false
  }),
  computed: {
    is_login() {
      return this.$store.getters.is_login
    },
    loading() {
      return this.$store.getters.loading
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  created() {
  //  console.log(this) 
    console.log("page::@/views/IndexStaff ")  ;
    extend('required', {
      ...required,
      message: this.$t('login.requiredMessage')
    })
    extend('email', {
      ...email,
      message: this.$t('login.emailMessage')
    })
    if (this.$route.query.psite)
      this.$cookies.set('psite', this.$route.query.psite)
    if (this.$route.query.recommend)
      this.$cookies.set('recommend', this.$route.query.recommend)
  },
  methods: {
    onKeydown(e) {
      if (
        e.keyCode === 101 ||
        e.keyCode === 69 ||
        e.keyCode === 45 ||
        e.keyCode === 43
      )
        e.preventDefault()
      if (e.target.value.length > 10) e.preventDefault()
    },
    focusPassword() {
      this.$refs.password.focus()
    },
    filterKo() {
      const koreanRegex = /[ㄱ-ㅎㅏ-ㅣ가-힣]/g
      return this.password.replace(koreanRegex, '')
    },
    submit() {
      this.$store.commit('loading', true)
      if (this.$refs.observer.validate()) {
        const params = {
          phone: this.phone.trim(),
          token: this.token.trim()
        }

        this.$store
          .dispatch('LOGIN', params)
          .then((res) => {
            if (!res) {
              throw new Error('no response')
            } else if (res.type === 'new') {
              this.submit()
            } else if (res.code === 'auth') {
              // if (this.autoLogin) {
              //   localStorage.accessToken = res.token
              // }
              // this.$store.dispatch('FETCH_USERINFO').then((res) => {
              // this.$store.commit('loading', false)

              //   try {
              //     loginSuccess(this.email, res.token)
              //   } catch (error) {
              //     this.$store.commit('loading', false)
              //     console.log(error)
              //   }
              //   if (!res.data.user.auth_sms || res.data.user.auth_sms === 'N') {
              //     this.$router.push('/phone/verify')
              //     return
              //   }

              //   this.$store.commit('activeMenu', 'home')
              // })
              this.$store.commit('loading', false)
              this.$router.replace({
                name: 'verify',
                params: { phone: params.phone }
              })
            } else if (res.code === 'email') {
              this.$store
                .dispatch('SEND_VERIFY_CODE', {
                  email: params.email
                })
                .then((response) => {
                  this.$store.commit('loading', false)
                  if (response.data.status) {
                    this.$router.push({
                      name: 'verify',
                      params: { email: params.email }
                    })
                  }
                })
            } else if (res.code === 'invalid') {
              this.$store.commit('loading', false)
              this.alert = true
              this.errors = this.$t('login.errors')
            } else throw res
          })
          .catch((error) => {
            this.$store.commit('loading', false)
            this.alert = true
            this.errors = this.$t('errorServer')
          })
      } else {
        this.$store.commit('loading', false)
        this.alert = true
        this.errors = this.$t('login.errors')
      }
    },
    scrollTo(elem) {
      let target
      if (elem === 'password') target = this.$refs.password
      if (elem === 'email') target = this.$refs.email

      this.$vuetify.goTo(target)
    }
  }
}
</script>

<style scoped>
.color-white {
  color: white !important;;
}

.login-container {
  padding: 4rem 2rem;
  height: 100%;
  max-width: 25rem;
  overflow: auto;
}
.links {
  display: flex;
  align-items: center;
}
.link-item {
  margin-left: 1rem;
}
.links a {
  color: #000;
}
</style>
